import { RootPage } from "../page";
import CompanySsoView from "./ssoView";
import CompanyUsersView from "./usersView";
import CompanyJoinsView from "./joinsView";
import CompanyAutoJoinView from "./autoJoin";
import CompanyEnforceMfaView from "./enforceMfa";

class SettingsIndexView extends RootPage {
  constructor() {
    super();

    CompanyUsersView(this);
    CompanyJoinsView(this);
    CompanyAutoJoinView(this);
    CompanyEnforceMfaView(this);
    CompanySsoView(this);

    this.isWorkDomain = this.getServerSideData("hasWorkDomain");

    var tab = this.GetQueryParam("tab");

    if (tab) {
      if (tab == "user") {
        this.setActiveTab("users");
      } else {
        this.setActiveTab("joins");
      }
    } else {
      this.setActiveTab("users");
    }
  }

  GetQueryParam(param) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    } catch {
      return null;
    }
  }

  onInit() {}
}

function GetQueryParam(param) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  } catch {
    return null;
  }
}

export default SettingsIndexView;
